import { render, staticRenderFns } from "./Suburb2.vue?vue&type=template&id=ccce55a8&"
import script from "./Suburb2.vue?vue&type=script&lang=js&"
export * from "./Suburb2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports